/** True when the tag report indicates at least one tag is applied somewhere in the script. */
export function tagDefinitionsReportHasAppliedUsage(
  rows: Array<{ scene_count?: number }> | undefined
): boolean {
  return (rows ?? []).some((r) => Number(r.scene_count) > 0);
}
